import {Entity} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'

export class UserAdEntity extends Entity {
  #adId
  #externalAdId
  #adUrl
  #category
  #daysSinceCreation
  #creationDate
  #encryptedAdId
  #daysToExpiration
  #expirationDate
  #isAppraisable
  #isDraft
  #isEditable
  #isErasable
  #isExpired
  #isExternal
  #isPublished
  #isRejected
  #isRenewable
  #isUnderReview
  #make
  #model
  #photo
  #price
  #rejection
  #stats
  #status
  #title
  #visibilityProducts

  constructor({
    adId,
    adUrl,
    category,
    creationDate,
    daysSinceCreation,
    daysToExpiration,
    encryptedAdId,
    expirationDate,
    externalAdId,
    isAppraisable,
    isDraft,
    isEditable,
    isErasable,
    isExpired,
    isExternal,
    isPublished,
    isRejected,
    isRenewable,
    isUnderReview,
    make,
    model,
    photo,
    price,
    rejection,
    stats,
    status,
    title,
    visibilityProducts
  }) {
    super()
    this.#adId = adId
    this.#externalAdId = externalAdId
    this.#adUrl = adUrl
    this.#category = category
    this.#creationDate = creationDate
    this.#daysToExpiration = daysToExpiration
    this.#daysSinceCreation = daysSinceCreation
    this.#encryptedAdId = encryptedAdId
    this.#expirationDate = expirationDate
    this.#isAppraisable = isAppraisable
    this.#isDraft = isDraft
    this.#isEditable = isEditable
    this.#isErasable = isErasable
    this.#isExpired = isExpired
    this.#isExternal = isExternal
    this.#isPublished = isPublished
    this.#isRejected = isRejected
    this.#isRenewable = isRenewable
    this.#isUnderReview = isUnderReview
    this.#make = make
    this.#model = model
    this.#photo = photo
    this.#price = price
    this.#rejection = rejection
    this.#stats = stats
    this.#status = status
    this.#title = title
    this.#visibilityProducts = visibilityProducts
  }

  static create({
    adId,
    adUrl,
    category,
    creationDate,
    daysToExpiration,
    daysSinceCreation,
    encryptedAdId,
    expirationDate,
    externalAdId,
    isAppraisable,
    isDraft,
    isEditable,
    isErasable,
    isExpired,
    isExternal,
    isPublished,
    isRejected,
    isRenewable,
    isUnderReview,
    make,
    model,
    photo,
    price,
    rejection,
    stats,
    status,
    title,
    visibilityProducts
  }) {
    return new UserAdEntity({
      adId,
      adUrl,
      category,
      creationDate,
      daysToExpiration,
      daysSinceCreation,
      encryptedAdId,
      expirationDate,
      externalAdId,
      isAppraisable,
      isDraft,
      isEditable,
      isErasable,
      isExpired,
      isExternal,
      isPublished,
      isRejected,
      isRenewable,
      isUnderReview,
      make,
      model,
      photo,
      price,
      rejection,
      stats,
      status,
      title,
      visibilityProducts
    })
  }

  static createFromApiResponse({
    adId,
    category = null,
    creationDate,
    daysToExpiration = null,
    daysSinceCreation = null,
    encryptedAdId = null,
    expirationDate = null,
    externalAdId = null,
    isAppraisable,
    isDraft = false,
    isEditable = false,
    isErasable = false,
    isExpired = false,
    isExternal = false,
    isPublished = false,
    isRejected = false,
    isRenewable = false,
    isUnderReview = false,
    mainPhoto,
    make,
    model,
    price,
    rejection = null,
    stats = null,
    status = null,
    title,
    visibilityProducts = []
  }) {
    const {ADS_DETAIL_PATH_PATTERN} = ConfigContext.get('page')

    let adUrl = null

    if (isUnderReview && encryptedAdId) {
      adUrl = `/preview/${encryptedAdId}/`
    } else if (isPublished) {
      adUrl = ADS_DETAIL_PATH_PATTERN.replace(':id', adId)
    }

    return UserAdEntity.create({
      adId,
      adUrl,
      category,
      creationDate,
      daysToExpiration,
      daysSinceCreation,
      encryptedAdId,
      expirationDate,
      externalAdId,
      isAppraisable,
      isDraft,
      isEditable,
      isErasable,
      isExpired,
      isExternal,
      isPublished,
      isRejected,
      isRenewable,
      isUnderReview,
      make,
      model,
      photo: mainPhoto,
      price,
      rejection,
      stats: stats ? {contacts: stats.nContacts, views: stats.adViews} : null,
      status,
      title,
      visibilityProducts
    })
  }

  getAdId() {
    return this.#adId
  }

  toJSON() {
    return {
      adId: this.#adId,
      adUrl: this.#adUrl,
      category: this.#category,
      daysToExpiration: this.#daysToExpiration,
      daysSinceCreation: this.#daysSinceCreation,
      externalAdId: this.#externalAdId,
      creationDate: this.#creationDate,
      encryptedAdId: this.#encryptedAdId,
      expirationDate: this.#expirationDate,
      isAppraisable: this.#isAppraisable,
      isDraft: this.#isDraft,
      isEditable: this.#isEditable,
      isErasable: this.#isErasable,
      isExpired: this.#isExpired,
      isExternal: this.#isExternal,
      isPublished: this.#isPublished,
      isRejected: this.#isRejected,
      isRenewable: this.#isRenewable,
      isUnderReview: this.#isUnderReview,
      make: this.#make,
      model: this.#model,
      photo: this.#photo,
      price: this.#price,
      rejection: this.#rejection,
      stats: this.#stats,
      status: this.#status,
      title: this.#title,
      visibilityProducts: this.#visibilityProducts
    }
  }
}
